export const isString = (unknown: unknown): unknown is string => typeof unknown === 'string';
